import ar from './ar.js';
import en from './en.js';
import { setStoredLang } from '../utils/storage.js';
import { EVENT, emit } from '../utils/events.js';

export const dictionaries = { ar, en };

let current = 'ar';

export function getLang() { return current; }

export function t(key) {
  const dict = dictionaries[current] || dictionaries.ar;
  const val = dict[key];
  return val === undefined ? key : val;
}

export function applyLanguage(lang) {
  if (!dictionaries[lang]) lang = 'ar';
  current = lang;
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  setStoredLang(lang);
  emit(EVENT.LANGUAGE_CHANGED, lang);
}

export function toggleLanguage() {
  applyLanguage(current === 'ar' ? 'en' : 'ar');
}